'use strict'; // Load modules

var _classCallCheck = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Any = require('../any');

var Hoek = require('hoek'); // Declare internals


var internals = {};

internals.Lazy =
/*#__PURE__*/
function (_Any) {
  _inherits(_class, _Any);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this));
    _this._type = 'lazy';
    return _this;
  }

  _createClass(_class, [{
    key: "_base",
    value: function _base(value, state, options) {
      var result = {
        value: value
      };
      var lazy = this._flags.lazy;

      if (!lazy) {
        result.errors = this.createError('lazy.base', null, state, options);
        return result;
      }

      var schema = lazy();

      if (!(schema instanceof Any)) {
        result.errors = this.createError('lazy.schema', null, state, options);
        return result;
      }

      return schema._validate(value, state, options);
    }
  }, {
    key: "set",
    value: function set(fn) {
      Hoek.assert(typeof fn === 'function', 'You must provide a function as first argument');
      var obj = this.clone();
      obj._flags.lazy = fn;
      return obj;
    }
  }]);

  return _class;
}(Any);

module.exports = new internals.Lazy();